import { MarketingCenteredText } from "../../components/MarketingCenteredTextBlock";
import { MarketingFooter } from "../../components/MarketingFooter";
import { MarketingMenu } from "../../components/MarketingMenu";
import { MarketingOGTags } from "../../components/MarketingOGTags";
import { BlogDesktop, MarketingTextSVGHeader } from "../../components/MarketingTextSVGHeader";
import { FadeUpContainer } from "../../components/ReusableStyledComponents/FadeUp";
import { MarketingInlineLink } from "../../components/ReusableStyledComponents/MarketingLink";
import { MarketingUL } from "../../components/ReusableStyledComponents/MarketingUl";
import { VerticalSpacing } from "../../components/VerticalSpacing";
import { theme } from "../../theme/theme";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

type DirectoryPageLayoutProps = {
    links?: string[];
    letter?: string;
};

const alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

export const DirectoryPageLayout = ({ links, letter }: DirectoryPageLayoutProps) => {
    const toRender = links || alphabet;
    const isIndex = !links;

    return (
        <>
            <MarketingMenu />
            <MarketingOGTags description="An archive or our public content and users" title="Directory" />
            <FadeUpContainer>
                <VerticalSpacing top={20} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 50 }]}>
                    <MarketingTextSVGHeader
                        title={<>Directory</>}
                        description={<>An archive or our public users and content</>}
                        desktopSVG={<BlogDesktop />}
                        mobileSVG={<></>}
                        textMaxWidth={850}
                        containerMaxWidth={1320}
                        textMarginTop={50}
                        mobileMaxWidth={343}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <VerticalSpacing top={60}>
                        <MarketingCenteredText
                            title={letter?.toUpperCase() || "Alphabetical Index"}
                            punchline={<></>}
                            description={
                                <>
                                    <MarketingUL>
                                        {toRender.map((item) => (
                                            <li key={item}>
                                                <MarketingInlineLink
                                                    target="_blank"
                                                    href={isIndex ? `${APPLICATION_ROUTES.DIRECTORY}/${item}` : item}
                                                >
                                                    {isIndex ? item.toUpperCase() : new URL(item).pathname.substring(1)}
                                                </MarketingInlineLink>
                                            </li>
                                        ))}
                                    </MarketingUL>
                                </>
                            }
                        />
                    </VerticalSpacing>
                </VerticalSpacing>
                <VerticalSpacing top={120}>
                    <MarketingFooter />
                </VerticalSpacing>
            </FadeUpContainer>
        </>
    );
};
